import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/components/App'

// Directives
import clickOutside from '@/directives/clickOutside'

Vue.directive('click-outside', clickOutside)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
